import { render, staticRenderFns } from "./tabs.mpx?vue&type=template&id=3b889ba7&scoped=true&component=true&componentId=tabs85698380"
import script from "./tabs.mpx?vue&type=script&lang=js&component=true&componentId=tabs85698380"
export * from "./tabs.mpx?vue&type=script&lang=js&component=true&componentId=tabs85698380"
import style0 from "./tabs.mpx?vue&type=style&index=0&id=3b889ba7&lang=stylus&scoped=true&mpxStyleOptions=%7B%22mid%22%3A%22m85698380%22%7D&component=true&componentId=tabs85698380"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b889ba7",
  null
  
)

export default component.exports